import { render, staticRenderFns } from "./QuestionDetailTable.vue?vue&type=template&id=402d28d0&scoped=true&"
import script from "./QuestionDetailTable.vue?vue&type=script&lang=ts&"
export * from "./QuestionDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionDetailTable.vue?vue&type=style&index=0&id=402d28d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d28d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSimpleTable,VTextarea})
